// Libs
import { useEffect, useState } from 'react';
import classNames from 'classnames/bind';
import { Grid2, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
import { BaseLabel } from '~/components/common';
// Others
import { EMPTY_VALUE } from '~/utils/constants/common';
import { IQuoteDetail } from '~/utils/interface/quotes';
import { IOrderDetail } from '~/utils/interface/order';
// Styles, images, icons
import styles from './EventDetailsQuoteDetail.module.scss';
import { icons } from '~/assets';

type Props = {
  orderDetail?: IOrderDetail;
  detailQuote?: IQuoteDetail;
};

const cx = classNames.bind(styles);

const EventDetailsQuoteDetail = (props: Props) => {
  //#region Destructuring Props
  const { detailQuote, orderDetail } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/quotes', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  const [data, setData] = useState<IQuoteDetail | IOrderDetail | undefined>(detailQuote || orderDetail);
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    setData(detailQuote || orderDetail);
  }, [detailQuote, orderDetail]);
  //#endregion Implement Hook

  //#region Handle Function
  const renderValueItem = (label: string, value: string) => {
    return (
      <Stack gap={1}>
        <Typography className={cx('label')}>{label}</Typography>
        <Typography className={cx('value')}>{value}</Typography>
      </Stack>
    );
  };
  //#endregion Handle Function

  return (
    <Stack id='eventDetailsQuoteDetailComponent' gap={6} className={cx('container')}>
      <BaseLabel styleType='title' label={t('quote_detail_title_event_details')} icon={icons.commonIconEventDetails} />

      <Grid2 container rowSpacing={4} columnSpacing={2}>
        <Grid2 size={6}>
          {renderValueItem(t('quote_detail_title_event_type'), data?.eventType?.name || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={6}>{renderValueItem(t('quote_detail_title_event_title'), data?.eventTitle || EMPTY_VALUE)}</Grid2>

        <Grid2 size={6}>
          {renderValueItem(t('quote_detail_title_delivery_address'), data?.deliveryAddress?.address || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={6}>
          {renderValueItem(t('quote_detail_title_pickup_address'), data?.pickupAddress?.address || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={3}>
          {renderValueItem(t('quote_detail_title_referral_source'), data?.referralSource || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={3}>
          {renderValueItem(t('quote_detail_title_repeat_business'), data?.repeatBusiness || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={3}>
          {renderValueItem(t('quote_detail_title_pricing_total'), data?.pricingTotal || EMPTY_VALUE)}
        </Grid2>

        <Grid2 size={3}>
          {renderValueItem(t('form_quotes_title_delivery_pick_up'), data?.deliveryOrPickUp || EMPTY_VALUE)}
        </Grid2>
      </Grid2>
    </Stack>
  );
};

export default EventDetailsQuoteDetail;
